/* eslint-disable no-mixed-operators */
import Constants from "../core/libraries/Constants";
import _ from "lodash";

export const getDepartmentFromDisplayName = (displayName: string) => {
    return displayName.split(' ').slice(-1).toString().replace('(', '').replace(')', '');
}

export const getDivisionFromDepartment = (department: string) => {
    const firstDiv = department.split('/')[0]
    return firstDiv.includes('-') && firstDiv.split('-')[0] || firstDiv;
}

export const convertToPageNumber = (top: number | undefined, skip: number | undefined) => {
    if (top === undefined || skip === undefined)
        return 0
    else
        return skip / top + 1;
}

export const convertToSkip = (pageNum: number | undefined, top: number | undefined) => {
    if (pageNum !== undefined && top !== undefined) {
        return top * pageNum - top;
    }
    return 0;
}

// use for query MS graph api
export const addAliasDomain = (userPrincipalName: string) => {
    const trimmedName = userPrincipalName.trim();
    return trimmedName.includes('@') || trimmedName.includes('-') ? trimmedName : `${trimmedName}${Constants.ALIAS_DOMAIN}`;
}

// query FEBER database
export const removeAliasDomain = (userPrincipalName: string) => {
    const trimmedName = userPrincipalName.trim();
    return trimmedName.includes(Constants.ALIAS_DOMAIN) ? trimmedName.replace(Constants.ALIAS_DOMAIN, "") : trimmedName;
}

export const convertToAliasDomainArr = (userPrincipalNames: string[]) => {
    return userPrincipalNames.length > 0 ? userPrincipalNames.map(name => addAliasDomain(name)) : []
}

export const convertToObjectIdList = (peoplePickerItems: any) => {
    let results: string[] = [];
    !!peoplePickerItems && peoplePickerItems.length > 0 && peoplePickerItems.forEach((person: any) => {
        !!person.id
            && results.push(removeAliasDomain(person.id))
            || typeof (person) === 'string'
            && results.push(removeAliasDomain(person))
    });
    return results;
}

export const convertToLoginNameList = (peoplePickerItems: any) => {
    let results: string[] = [];
    !!peoplePickerItems && peoplePickerItems.length > 0 && peoplePickerItems.forEach((person: any) => {
        !!person.loginName
            && results.push(removeAliasDomain(person.loginName))
            || typeof (person) === 'string'
            && results.push(removeAliasDomain(person))
    });
    return results;
}

export const convertPeopleAndGroupObjectArrToStringArr = (peopleAndGroupArrAsString: any): string[] => {
    try {
        let array = JSON.parse(peopleAndGroupArrAsString)
        return !!array && array.length > 0 && array.map((item: { PeopleAndGroupId: string; PeopleId: string; }) => item.PeopleAndGroupId || item.PeopleId) || [] as string[]
    } catch (error) {
        console.log(error);
        return [] as string[];
    }
}


export const convertFromCamelCaseToPascalCase = (object: any) => {
    return _.mapKeys(object, (v, k) => _.startCase(_.camelCase(k)).replace(/ /g, ''))
}

export const convertToIDMGroupName = (division: string, uploadType: string, isAdmin: boolean = true) => {
    division = division !== "" ? `_${division}` : division;
    uploadType = uploadType !== "" ? `_${uploadType}` : uploadType;
    return `idm2bcd_feber${division}${uploadType}_${isAdmin && "admin" || "user"}`
}

export const convertToIndexedDbName = (userId: string) => {
    return `0ae51e19-07c8-4e4b-bb6d-648ee58410f4${userId}`;
}
